import { FormattedMessage } from 'react-intl'
import { JoyrideCustomTooltip } from '../ui/joyrideTooltip/JoyrideCustomTooltip.tsx'
import { ReactNode } from 'react'

/** Product click-tours. Set to true to re-enable. */
export const JOYRIDE_ENABLED = false

export const programPageJoyrideProps = {
  continuous: true,
  showSkipButton: false,
  hideCloseButton: true,
  hideBackButton: true,
  showProgress: false,
  disableScrollParentFix: false,
  disableScrolling: false,
  scrollOffset: 110,
  spotlightPadding: 8,
  spotlightClicks: false,
  disableOverlayClose: true,
  disableCloseOnEsc: true,
  disableBeacon: true,
  disableButton: false,
  tooltipComponent: JoyrideCustomTooltip,
  styles: {
    spotlight: {
      borderRadius: 22,
    },
    tooltip: {
      borderRadius: 16,
      paddingBottom: 24,
      padding: 16,
    },
  },
}

export const getLearnProfileEndStep = ({ link }: { link: ReactNode }) => {
  return [
    {
      target: 'body',
      placement: 'center' as const,
      spotlightPadding: 0,
      imagePlace: 'top-center',
      edmanImageSize: 'large',
      nextStepText: 'Закрыть',
      styles: {
        tooltip: {
          width: '400px',
          padding: '24px',
        },
        overlay: {
          backgroundColor: 'rgba(0, 0, 0, 0.7)',
        },
      },
      content: (
        <>
          <div>
            Вы большой молодец! Вы справились лучше, чем 85% пользователей!
            Дальше вас ждет 650+ уроков и неограниченная тренировка словаря! 🚀{' '}
          </div>
          <br />
          <div>
            Дайте знать, если у вас возникнут вопросы через форму {link}.
          </div>
        </>
      ),
    },
  ]
}

export const DESKTOP_PROGRAM_TOUR_STEPS = [
  {
    target: 'body',
    content: (
      <span>
        <span>
          Рад вас видеть! 🤗 Немножко расскажу, что у меня есть, чтобы помочь
          вам освоиться!
        </span>
      </span>
    ),
    placement: 'center' as const,
    spotlightPadding: 0,
    imagePlace: 'top-center',
    edmanImageSize: 'large',
    styles: {
      tooltip: {
        width: '300px',
        padding: '16px !important',
      },
      overlay: {
        backgroundColor: 'rgba(0, 0, 0, 0.7)',
      },
    },

    showSkipButton: false,
  },
  {
    target: '#level-select-container',
    imagePlace: 'left',
    placement: 'left' as const,
    styles: {
      spotlight: {
        borderRadius: 30,
      },
      tooltip: {
        width: '300px',
        paddingBottom: '40px',
      },
    },
    content: (
      <span>
        Это указанный вами уровень языка. Начнем мы с этого уровня. Вы всегда
        можете его изменить🙂
      </span>
    ),
  },
  {
    target: '#topic-select-container',
    content: (
      <span>
        <span>
          На каждом уровне персональные интересные темы - от искусства до
          технологий. Выбирайте темы здесь 🌟.
        </span>
      </span>
    ),
    imagePlace: 'bottom',
    placement: 'bottom' as const,
    styles: {
      spotlight: {
        borderRadius: 30,
      },
      tooltip: {
        width: '300px',
        paddingBottom: '40px',
      },
    },
  },
  {
    target: '#units-0-lessons',
    content: (
      <span>
        <FormattedMessage id="joyride.content.unitLessons" />
      </span>
    ),
    placement: 'top' as const,
    imagePlace: 'right',
    spotlightClicks: false,
  },
  {
    target: '#units-0-dashed-line-svg',
    content: (
      <span>
        Мы будем с вами последовательно двигаться по урокам. Я буду отслеживать
        ваш результат и давать вам обратную связь.
      </span>
    ),
    offset: 24,
    placement: 'right-start' as const,
    imagePlace: 'right',

    styles: {
      spotlight: {
        transform: 'translate(-10px, 2px)',
        padding: 20,
        paddingBottom: 36,
      },
      tooltip: {
        marginTop: 40,
        top: 64,
        paddingBottom: '40px',
      },
    },
  },
  {
    target: '#lesson-joyride-0',
    content: (
      <span>
        <span>Давайте скорее начинать 🙂</span>
        <br />
        <span className="font-extrabold">Нажмите на первый урок! 🚀</span>
      </span>
    ),
    placement: 'top' as const,
    spotlightClicks: true,
    imagePlace: 'right',
    imageClassname: 'top-[-12px]',
    disableButton: true,
    styles: {
      tooltip: {
        paddingBottom: '40px',
      },
    },
  },
]

export const MARKETING_PRACTICE_TOUR_STEP = [
  {
    target: '#navbar-vocabPlus',
    placement: 'right' as const,
    spotlightPadding: 4,
    imagePlace: 'right',
    disableButton: true,
    disableBeacon: true,
    spotlightClicks: true,
    content:
      'Вы справились со своим первым уроком! А сейчас мы с вами перейдем в Словарик+, где сыграем в одну игру!',
    styles: {
      spotlight: {
        borderRadius: 30,
      },
      tooltip: {
        paddingBottom: '24px',
      },
    },
  },
]

export const PRACTICE_TOUR_STEPS = [
  {
    target: '#practice-header',
    content:
      'Сначала скажу, откуда это число. У вас 50 стартовых слов, исходя из вашего уровня, а остальное добавляете вы или я по мере открытия вами новых тем.',
    disableBeacon: true,
    placement: 'bottom' as const,
    styles: {
      tooltip: {
        width: '300px',
        paddingBottom: '40px',
      },
      tooltipContainer: {
        padding: '24px',
      },
    },
    spotlightPadding: 16,
    imagePlace: 'left-end',

    disableButton: false,
    disableOverlayClose: true,
    spotlightClicks: false,
  },
  {
    target: '#practice-progress-block',
    content:
      'Это распределение ваших слов по новым, слабым и сильным. Меняется после каждой игры',
    disableBeacon: true,
    placement: 'top' as const,
    spotlightPadding: 16,
    imagePlace: 'left',
    disableButton: false,
    disableOverlayClose: true,
    disableCloseOnEsc: true,
    spotlightClicks: false,
    styles: {
      tooltip: {
        width: '300px',
        paddingBottom: '40px',
      },
      tooltipContainer: {
        padding: '24px',
      },
    },
  },
  {
    target: '#vocab-lesson-0',
    content: (
      <span>
        Давайте попробуем пройти игру Match Game!
        <span className="font-extrabold"> Нажмите скорее</span>
      </span>
    ),
    disableBeacon: false,
    placement: 'top' as const,
    spotlightPadding: 8,
    imagePlace: 'left',
    imageClassname: 'top-[-12px]',
    disableButton: true,
    disableOverlayClose: true,
    disableCloseOnEsc: true,
    spotlightClicks: true,
    styles: {
      tooltip: {
        width: '300px',
        paddingBottom: '24px',
      },
      tooltipContainer: {
        padding: '24px',
      },
    },
  },
]

export const joyrideProps = {
  edmanImageSize: 'medium',
  continuous: true,
  showSkipButton: false,
  hideCloseButton: true,
  hideBackButton: true,
  showProgress: false,
  disableOverlayClose: true,
  spotlightPadding: 8,
  disableScrollParentFix: false,
  disableCloseOnEsc: true,
  disableScrolling: false,
  scrollOffset: 110,
  locale: {
    next: 'Закрыть',
    last: 'Закрыть',
  },
  styles: {
    spotlight: {
      borderRadius: 22,
    },
    tooltip: {
      borderRadius: 16,
      paddingBottom: 32,
      padding: 16,
    },
  },
  tooltipComponent: JoyrideCustomTooltip,
}
